import React from 'react';
import moment from 'moment';

import Button from '../../helpers/Button';

import { formatDollar } from '../../../utils/CurrencyFormatter';

const TaskReceipt = ({ activityTitle, task, no, acreage, cropImg }) => {
  return (
    <div className="bg-white rounded shadow-cfw p-4 md:p-6 mb-10">
      <div className="flex md:flex-wrap justify-between items-center">
        <div className="flex">
          <img
            className="md:block hidden inline-block h-16 md:h-24 w-16 md:w-24 object-cover rounded-full"
            src={task.album[0] || cropImg}
            alt={task.title}
          />
          <div className="ml-2">
            <h5 className="text-base font-bold">{activityTitle + ' - ' + task.title}</h5>
            <small className="block">
              Date of transaction - {moment(task.updatedAt).format('DD MMMM, YYYY')}
            </small>
            <small className="block">Receipt number - {no} </small>
            <small className="block">
              Amount -{' '}
              <span className="text-base text-cf-300">{formatDollar(task.cost * acreage)}</span>{' '}
            </small>
          </div>
        </div>

        <div className="flex flex-col float-right relative right-0 mt-1">
          <Button
            name={'Input - ' + task.input}
            className="text-sm md:text-base mr-1 mb-1 border-2 border-cf-300 text-cf-300 rounded p-1 focus:outline-none"
          />
          <Button
            name={'Tool - ' + task.tool}
            className="text-sm md:text-base mr-1 mb-1 border-2 border-cf-300 text-cf-300 rounded p-1 focus:outline-none"
          />
          <Button
            name={'Labour - ' + task.labour}
            className="text-sm md:text-base mr-1 mb-1 border-2 border-cf-300 text-cf-300 rounded p-1 focus:outline-none"
          />
        </div>
      </div>
    </div>
  );
};

export default TaskReceipt;
